<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-toolbar-title>Your Daily Update stats</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <!-- Chart -->
      <apexchart
        v-if="loaded"
        type="area"
        width="100%"
        height="400"
        :options="chartOptions"
        :series="series"
      ></apexchart>
      <v-skeleton-loader
        v-else
        class="mx-auto"
        type="image"
      ></v-skeleton-loader>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import axios from "@/plugins/axios";

export default {
  data() {
    return {
      chartOptions: null,
      series: [],
      loaded: false,
    };
  },
  props: {
    agentEmail: {
      type: String,
    },
  },
  mounted() {
    this.getChartData();
    setInterval(() => {
      this.getChartData();
    }, 60000);
  },
  methods: {
    getChartData() {
      let that = this;
      axios
        .get(`/api/v1/bot-home/updates/${that.agentEmail}`)
        .then((response) => {
          // Stacked chart data
          that.series = response.data.data;
          let labels = response.data.dates;
          that.chartOptions = {
            colors: ["#f5da42", "#f53131", "#1db0e0", "#4a4a4a", "#969696"],
            tooltip: {
              theme: "dark",
            },
            chart: {
              type: "area",
              height: 600,
              stacked: true,
            },
            xaxis: {
              categories: labels,
              labels: {
                formatter: function (val) {
                  return moment(val).format("dddd - DD MMM YYYY");
                },
              },
            },
          };
          that.loaded = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
